<template>
    <!-- //Only shows if options is present -->
    <div class="card card-search" v-if="options.length > 0">
        <div class="card-body p-0">

            <!-- Button for showing the search box -->
            <div class="box-header">
                <a :class="{'collapsed':collapse}" class="d-block" data-toggle="collapse" href="#collapseFilter" aria-expanded="false"
                   aria-controls="collapseFilter">
                    <h6 class="box-title p-3 m-0"><i class="fa fa-filter"></i> Search</h6>
                </a>
            </div>

            <!-- The searchbox content -->
            <div :class="{'show':collapse}" class="table-wrapper collapse pl-3 pr-3 pb-3 pt-0" id="collapseFilter">
                <form action="" method="get" @submit.prevent="sendForm">
                    <!-- <input type="hidden" name="_token" :value="csrf"> -->

                    <!-- //Loops for every item in itemsSearch data property -->
                    <div class="row" v-for="(item, key) in itemsSearch" :key="key">
                        
                        <!-- select for search column -->
                        <div class="col col-md-3">
                            <div class="form-group">
                                <label class="col-form-label">Search key</label>

                                <!-- Select puts into item.option -->
                                <select class="form-control" name="search[keys][]" v-model="item.option"
                                        @change.prevent="item.type=''">
                                    <option value="">Select..</option>
                                    <option v-for="(option, index) in options" :key="index"
                                            :value="{type: option.type, column: option.column, options: option.options, search: option.search}">
                                        {{ option.label }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="col col-md-2" v-if="item.option.type != 'search'">
                            <div class="form-group">
                                <label class="col-form-label">Search type</label>
                                <select class="form-control" name="search[types][]" v-model="item.type"
                                        @change.prevent="item.value={}">
                                    <option value="">Select..</option>

                                    <option v-if="item.option.type == 'text'" value="contains">Contains</option>
                                    <option v-if="item.option.type == 'text'" value="equals_text">Equals</option>
                                    <option v-if="item.option.type == 'text'" value="between">Between</option>


                                    <option v-if="item.option.type == 'number'" value="equals_number">Equals</option>
                                    <option v-if="item.option.type == 'number'" value="more_than">More than</option>
                                    <option v-if="item.option.type == 'number'" value="less_than">Less than</option>
                                    <option v-if="item.option.type == 'number'" value="between">Between</option>
                                    
                                    <option v-if="item.option.type == 'select'" value="is">Is</option>
                                    <option v-if="item.option.type == 'select'" value="is_not">Is not</option>

                                    <option v-if="item.option.type == 'date'" value="after_than">After than</option>
                                    <option v-if="item.option.type == 'date'" value="before_than">Before than</option>
                                    <option v-if="item.option.type == 'date'" value="between_date">Between</option>
                                    <!-- <option v-if="item.option.type == 'date'" value="year">Year</option>
                                    <option v-if="item.option.type == 'date'" value="month">Month</option> -->
                                </select>
                            </div>
                        </div>

                        <div class="col col-md-2 form-group" v-if="item.option.type == 'search'">
                            <label class="col-form-label">Search records</label>
                            <input type="text" class="form-control" name="search[values][]" v-model="item.search" @change.prevent="listOptions(item)" autocomplete="off">
                        </div>

                        <div class="col" v-if="item.option.type">
                            <div class="form-group">
                                <label class="col-form-label">Search value</label>
                                <input v-if="item.type == 'contains'" type="text" class="form-control"
                                       name="search[values][]" v-model="item.value.contains" autocomplete="off">
                                <input v-if="item.type == 'equals_text'" type="text" class="form-control"
                                       name="search[values][]" v-model="item.value.equals" autocomplete="off">

                                <input v-if="item.type == 'equals_number'" type="number" step="1" min="0"
                                       class="form-control" name="search[values][]" v-model="item.value.equals"
                                       autocomplete="off">

                                <input v-if="item.type == 'more_than'" type="number" step="1" min="0"
                                       class="form-control" name="search[values][]" v-model="item.value.more_than"
                                       autocomplete="off">
                                <input v-if="item.type == 'less_than'" type="number" step="1" min="0"
                                       class="form-control" name="search[values][]" v-model="item.value.less_than"
                                       autocomplete="off">

                                <div class="row pr-2" v-if="item.type == 'between'">
                                    <input type="number" step="1" min="0" class="form-control col mr-md-2"
                                           name="search[values][]" v-model="item.value.between_start"
                                           autocomplete="off">
                                    <input type="number" step="1" min="0" class="form-control col"
                                           name="search[values][]" v-model="item.value.between_end" autocomplete="off">
                                </div>

                                <input v-if="item.type == 'after_than'" type="date" class="form-control"
                                       name="search[values][]" v-model="item.value.more_than" autocomplete="off">
                                <input v-if="item.type == 'before_than'" type="date" class="form-control"
                                       name="search[values][]" v-model="item.value.less_than" autocomplete="off">

                                <select v-if="item.type == 'year'" class="form-control" v-model="item.value.equals">
                                    <option v-for="year in years(2015)" :key="year">{{ year }}</option>
                                </select>

                                <select v-if="item.type == 'is'" class="form-control" v-model="item.value.equals">
                                    <option value="">Select..</option>
                                    <option v-for="option in item.option.options" :key="option.value" :value="option.value"><span v-if="option.label">{{ option.label }}</span><span v-else>{{ option.value }}</span></option>
                                </select>

                                <select v-if="item.type == 'is_not'" class="form-control" v-model="item.value.equals_not">
                                    <option value="">Select..</option>
                                    <option v-for="option in item.option.options" :key="option.value" :value="option.value"><span v-if="option.label">{{ option.label }}</span><span v-else>{{ option.value }}</span></option>
                                </select>
                                
                                <select v-if="item.type == 'search'" class="form-control" v-model="item.value.equals">
                                    <option value="">Select..</option>
                                    <option v-for="option in item.option.options" :key="option.value" :value="option.value"><span v-if="option.label">{{ option.label }}</span><span v-else>{{ option.value }}</span></option>
                                </select>

                                <div class="row pr-2" v-if="item.type == 'month'">
                                    <select class="form-control col mr-md-2" v-model="item.value.year">
                                        <option v-for="year in years(2015)" :key="year">{{ year }}</option>
                                    </select>
                                    <select class="form-control col" v-model="item.value.month">
                                        <option v-for="(month, index) in monthNames" :value="index+1" :key="index">
                                            {{ month }}
                                        </option>
                                    </select>
                                </div>

                                <div class="row pr-2" v-if="item.type == 'between_date'">
                                    <input type="date" class="form-control col mr-md-2" name="search[values][]"
                                           v-model="item.value.between_start" autocomplete="off">
                                    <input type="date" class="form-control col" name="search[values][]"
                                           v-model="item.value.between_end" autocomplete="off">
                                </div>

                            </div>
                        </div>

                        <div class="col-2 col-md-1 mt-1">
                            <div class="form-group mt-3" v-if="key != 0">
                                <a class="btn btn-sm btn-danger mt-4" @click.prevent="removeItem(key)">
                                    <i class="fa fa-trash text-white"></i>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-4 pull-left">
                            <div class="form-group mr-2 d-inline-block mb-0">
                                <a role="button" class="btn btn-success text-white mb-0" name="submit"
                                   @click.prevent="addItem">
                                    <i class="fa fa-plus"></i> Add
                                </a>
                            </div>
                            <div class="form-group d-inline-block mb-0">
                                <button type="submit" class="btn btn-info mb-0" name="submit">
                                    <i class="fa fa-filter"></i> Search
                                </button>
                            </div>
                        </div>
                    </div>

                </form>
            </div>

        </div>
    </div>

</template>

<script>

import {monthNames, URL_BASE, years} from '../../utils/helper';

export default {
    name: "SearchBoxComponent",
    props: {
        // [{column: '', label: '', type: ''}, ... ]
        options: {
            type: Array,
            default: []
        },
        current: {
            type: Array
        }
    },
    data() {
        return {
            monthNames: [],
            itemsSearch: [],
            collapse: false
        }
    },
    methods: {

        listOptions(item = {}) {
            item.type = 'search';
            console.log(JSON.parse(JSON.stringify(item)));
            axios.post(item.option.search.route, { search: item.search })
            .then(res => {
                item.option.options = res.data;
                console.log(JSON.parse(JSON.stringify(item)));
            }).catch(err => {
                console.error(err)
            });
        },

        //Imported method from UTILS
        years: years,

        // Adds new filter row
        addItem(item = {}) {
            if (item.hasOwnProperty('value')) {
                this.collapse = true;
                let option = this.options.filter((element) => {
                    return element.column == item.field;
                })[0];

                let typeName = this.getOperator(item.value, option.type)
                let valueFiltered = this.getValueByOperator(item.value, option.type)
                
                this.itemsSearch.push({
                    option: {type: option.type, column: option.column, options: option.options, search: option.search},
                    type: typeName,
                    value: valueFiltered
                })
            } else {
                this.itemsSearch.push({option: {}, type: '', value: {}})
            }
        },

        //Removes row from the filter
        removeItem(itemIndex) {
            if (this.itemsSearch.length > 1) {
                this.itemsSearch.splice(itemIndex, 1);
            }
        },

        getWhereClosure(name, orWhere) {

            let whereClosure = '';
            return (orWhere) ? 'or[' + name + ']' : name
        },

        getUrlParamByItem(item, orWhere) {

            let urlParam = ''

            switch (item.type) {
                case 'search':
                case 'equals_text':
                case 'equals_number':
                case 'is': 
                case 'year':
                    urlParam = this.getWhereClosure(item.option.column, orWhere) + '=' + item.value.equals
                    break
                case 'is_not': 
                    urlParam = this.getWhereClosure(item.option.column, orWhere) + '[operator]=!=' + 
                    '&' + this.getWhereClosure(item.option.column, orWhere) + '[value]=' + item.value.equals_not
                    break
                case 'contains':
                    urlParam = this.getWhereClosure(item.option.column, orWhere) + '[like]=%25' + item.value.contains + '%25'
                    break
                case 'more_than':
                case 'after_than':
                    urlParam = this.getWhereClosure(item.option.column, orWhere) + '[operator]=>' +
                        '&' + this.getWhereClosure(item.option.column, orWhere) + '[value]=' + item.value.more_than
                    break
                case 'less_than':
                case 'before_than':
                    urlParam = this.getWhereClosure(item.option.column, orWhere) + '[operator]=<' +
                        '&' + this.getWhereClosure(item.option.column, orWhere) + '[value]=' + item.value.less_than
                    break

                case 'between_date':
                case 'between':
                    urlParam = this.getWhereClosure(item.option.column, orWhere) + '[start]=' + item.value.between_start +
                        '&' + this.getWhereClosure(item.option.column, orWhere) + '[end]=' + item.value.between_end
                    break

                // case 'month':
                //   urlParam = this.getWhereClosure(item.option.column, orWhere) + '[operator]=>' +
                //   '&'+this.getWhereClosure(item.option.column, orWhere) + '[value]=' + item.value
                //   break
            }

            return urlParam;

        },

        getOperator(value, type) {

            if (value.hasOwnProperty('start')) {
                if (type === 'date') return 'between_date'
                return 'between'
            }

            if (value.hasOwnProperty('operator')) {
                if (value.operator == "<") {
                    if (type === 'date') return 'before_than'
                    if (type === 'number') return 'less_than'
                }
                if (value.operator == ">") {
                    if (type === 'date') return 'after_than'
                    if (type === 'number') return 'more_than'
                }
                
                if (value.operator == "!=") {
                    return 'is_not';
                }
            }
            
            if (value.hasOwnProperty('like')) {
                return 'contains'
            }

            if (type === 'select') {
                return 'is';
            }

            if (type === 'search') {
                return 'search'
            }
            return 'equals_' + type
        },

        getValueByOperator(value, type) {
            if (value.hasOwnProperty('start')) {
                return {between_start: value.start, between_end: value.end,}
            }

            if (value.hasOwnProperty('operator')) {
                if (value.operator == "<") {
                    return {less_than: value.value}
                }
                if (value.operator == ">") {
                    return {more_than: value.value}
                }

                if (value.operator == "!=") {
                    return {equals_not: parseInt(value.value)}
                }
            }

            if (value.hasOwnProperty('like')) {
                let val = value.like.replaceAll('%', '')
                return {contains: val}
            }


            return {equals: value}
        },

        //refreshes the page with the new params
        sendForm() {
            let url = '//' + location.host + location.pathname

            this.itemsSearch.forEach((item, index) => {

                if (item.type != '') {

                    url += (index === 0) ? '?' : '&'

                    // url += this.getUrlParamByItem(item, !(index === 0))
                    url += this.getUrlParamByItem(item, false)
                }

            });

            window.location.href = url
        },

        //Restauration of the previous filter
        getUrlVars() {
            var vars = {};
            var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,
                function (m, key, value) {
                    vars[key] = value;
                });
            return vars;
        }
    },
    mounted() {
        if (this.current.length > 0) {
            this.current.forEach((item, index) => {
                this.addItem(item);
            });
        }else{
            this.addItem()
        }
        this.monthNames = monthNames;
    }
}
</script>

<style>
.card-search .box-header a:hover {
    background-color: #eee !important;
    border-bottom: 0;
    text-decoration: none;
}

select {
    height: 37px;
}
</style>
